"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = void 0;
var getErrorMessage = function (errorMessage) {
    switch (errorMessage.message) {
        case 'error.gameTicketEntry.dailyLimitReached':
            return 'You have used the maximum number of ticket validation per day. Try again tomorrow.';
        case 'error.gameTicketEntry.lockoutEntryAttempt':
            return 'Ticket validation is temporarily disabled. Please try again after some time.';
        case 'error.gameTicketEntry.duplicateOther':
        case 'error.gameTicketEntry.invalid':
            return "Your ticket has already been entered or is not valid.";
        case 'error.gameTicketEntry.duplicateSelf':
            return 'You have already made this entry.';
        case 'error.gameTicketEntry.gameEnded':
            return 'Entries for this game are no longer accepted.';
        case 'error.gameTicketEntry.gameNotStarted':
            return "This game hasn't started yet.";
        case 'error.gameTicketEntry.jackpot':
            return 'Ticket has already been entered.';
        default:
            return 'There was a problem processing this entry. Please try again.';
    }
};
exports.getErrorMessage = getErrorMessage;
//# sourceMappingURL=utils.js.map